<template>
  <div>
    <h1 class="page-title">Edit event</h1>
    <EventForm v-if="event" :event="event" />
  </div>
</template>

<script>
import EventForm from "@/components/molecules/EventForm";
import { mapState } from "vuex";

export default {
  components: { EventForm },
  computed: mapState({
    event: (state) => state.events.currentEvent,
  }),
};
</script>
